import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { company } from "../mock";

const points = [
  "Free, no-obligation roof inspections",
  "Qualify to replace your roof with little or no out-of-pocket cost",
  "We handle the insurance claim from start to finish",
];

const QualifySection = () => {
  return (
    <section className="bg-brand-navy py-20 relative overflow-hidden">
      <div className="absolute -bottom-32 -left-20 w-96 h-96 bg-brand-orange/10 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/10">
          <img
            src="https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/fc6e53pk_How-Storm-Damage-Shows-Up-on-Your-Roof.webp"
            alt="Home with storm-damaged roof"
            className="w-full h-[380px] object-cover"
          />
        </div>

        <div>
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            Storm Damage & Insurance
          </p>
          <h2 className="font-display font-extrabold text-white text-3xl md:text-4xl leading-tight mb-5">
            Get Your Roof Repaired or Replaced
          </h2>
          <p className="text-white/75 leading-relaxed mb-6">
            Your roof is your building's first line of defense against the
            elements. Noticed damp spots, visible leaks, or other symptoms of
            roof damage? We can help — you may even qualify to get your roof
            replaced with little or no out-of-pocket cost to you.
          </p>

          <div className="space-y-3 mb-8">
            {points.map((p) => (
              <div key={p} className="flex items-start gap-3 text-white/90">
                <CheckCircle2 className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" />
                <span>{p}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold px-6 py-3.5 rounded-full shadow-lg transition-all hover:-translate-y-0.5"
            >
              Contact Us Today
              <ArrowRight className="w-5 h-5" />
            </Link>
            <a
              href={company.phoneHref}
              className="inline-flex items-center gap-2 bg-white/5 border border-white/25 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-white/10 transition-all"
            >
              {company.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualifySection;
